module.exports = __webpack_public_path__ + "img/background_c3-2_mobile.31760915.jpg";